export default __webpack_public_path__ + "static/ngBucharest_logo@2x-45508a358d6be4e4d6d0080094cae162.png";